import { Card, InfoRow } from './BmsCardPrimitives'

const VersionInfoCard = ({ bms, className = '' }) => (
  <Card className={className}>
    <InfoRow label="Firmware version" value={bms.firmwareVersion} />
    <InfoRow label="Hardware version" value={bms.hardwareVersion} />
  </Card>
)

export default VersionInfoCard
